/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import Cookies from "js-cookie";


const getAuthToken = (tokenType = "wl_xxid_acc") => {
  const authToken = Cookies.get(tokenType) || null;
  return authToken;
};

export default getAuthToken;
